<section class="FirstScroll_Section">
    <div class="container nopad">
        <div class="row">
          <div class="col-sm-4 py-3 py-sm-0" *ngFor="let image of imageGallery">
            <div class="card box-shadow">
              <img src="{{baseUrl}}/{{image.images[0]?.file}}" class="card-img-top" alt="..." style="height: 250px;">
              <div class="card-body">
                <h4 class="card-title">{{image?.date| date:'d'}} {{image?.date| date:'MMM'}} {{image?.date| date:'YYYY'}}<span class="totalImages"><i  class="fa fa-image"></i> &nbsp;{{image.images.length}} +</span> </h4>
                <p class="card-text">{{image.title}}</p>
                <a href="{{baseUrl}}/{{image.images[0]?.file}}" rel="lightbox[{{image.id}}]" class="btn viewButton view"><i class="fa fa-eye"></i>View</a>
                <!-- <a href="assets/images/homeSlide2.jpg" rel="lightbox[product_1]"></a>
                <a href="assets/images/homeSlide3.jpg" rel="lightbox[product_1]"></a> -->
                <a *ngFor="let files of image.images.slice(1)" href="{{baseUrl}}/{{files?.file}}" rel="lightbox[{{image.id}}]"></a>
            </div>
            </div>
          </div>
          
        </div>
      </div>
    </section>
    
